import SearchCustomers from './SearchCustomers';

export default SearchCustomers;
